export const termsToggle = {
    init: function () {
        document.body.addEventListener('click', this.toggleTerms);
    },

    toggleTerms: function (e) {
        const target = e.target;

        if (
            !target.matches('a.woocommerce-terms-and-conditions-link') &&
            !target.closest('a.woocommerce-terms-and-conditions-link')
        ) {
            return;
        }

        const termsAndConditions = document.querySelector('.woocommerce-terms-and-conditions');
        if (termsAndConditions) {
            termsAndConditions.classList.toggle('d-none');
            return false;
        }
    },
};
